import { useEffect, useState } from "react";
import { StatusShell } from "../components/StatusShell";
import { SuccessView } from "../components/SuccessView";

/**
 * The thank-you page shows the reveal animation only when the visitor arrived
 * from the form (the flag lives in sessionStorage), never on a direct visit.
 */
export function ThankYouPage() {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    let arrived = false;
    try {
      arrived = sessionStorage.getItem("qurtuba:submitted") === "1";
      if (arrived) sessionStorage.removeItem("qurtuba:submitted");
    } catch {
      arrived = false;
    }
    if (arrived) setAnimate(true);
  }, []);

  return (
    <StatusShell>
      <SuccessView animate={animate} />
    </StatusShell>
  );
}
